import {useMemo} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {
  setPopulationAggregationState,
  setLoadingAggregationsState,
  setMissingStates as setMissingStatesAction,
  selectPopulationAggregationState,
  selectLoadingAggregationsState,
  selectMissingStates
} from '../slices/populationAggregationSlice'

export const usePopulationAggregation = () => {
  const dispatch = useDispatch()
  const populationAggregationState = useSelector(selectPopulationAggregationState)
  const loadingAggregationsState = useSelector(selectLoadingAggregationsState)
  const missingStates = useSelector(selectMissingStates)

  return useMemo(
    () => ({
      populationAggregationState,
      loadingAggregationsState,
      missingStates,
      setPopulationAggregationState: (data) => dispatch(setPopulationAggregationState(data)),
      setLoadingAggregationsState: (loading) => dispatch(setLoadingAggregationsState(loading)),
      setMissingStates: (missing) => dispatch(setMissingStatesAction(missing))
    }),
    [populationAggregationState, loadingAggregationsState, missingStates, dispatch]
  )
}
